export default {
  provinces: {
    loading: false,
    error: null,
    data: [],
  },
};
